import React, { useContext } from 'react'
import PermanenceReportContext from '../../context/PermanenceReportContext/PermanenceReportContext';
import AccessOpeningContext from '../../context/AccessOpeningContext/AccessOpeningContext';
import ContractorsContext from '../../context/ContractorsContext/ContractorsContext';
import EmployeeContractTypeContext from '../../context/EmployeeContractTypeContext/EmployeeContractTypeContext';
import { CustomTabletFilter } from '../CustomTabletFilter/CustomTabletFilter';
import { t } from 'i18next';
import { getTenantInfoByKey } from '../../helpers/helpers';
import AccessBuildingContext from '../../context/AccessBuildingContext/AccessBuildingContext';

const PermanenceTabletFilters = () => {

  const { permanenceReportState, handleGetPermanenceReport } = useContext(PermanenceReportContext);
  const { reportFilter } = permanenceReportState;
  const { employeeContractTypeState } = useContext(EmployeeContractTypeContext);
  const { contractEmployeeTypes } = employeeContractTypeState;
  const contractEmployeeTypeFilter = contractEmployeeTypes.find(contractEmployeeType => reportFilter.contract_type.some(contract_type => contract_type === contractEmployeeType.code));

  const { contractorsState } = useContext(ContractorsContext);
  const { contractors } = contractorsState;
  const contractorsFilter = contractors.find(contractorFilter => reportFilter.contractors.some(contractor => contractor === contractorFilter.contractor_id));

  const { accessOpeningState } = useContext(AccessOpeningContext);
  const { accessOpenigs } = accessOpeningState;
  const accessOpenigFilters = accessOpenigs.filter(accessOpenig => reportFilter.opening_code.find(opening_code => opening_code === accessOpenig.codigo));

  const { accessBuildingState } = useContext(AccessBuildingContext);
  const { accessBuildings } = accessBuildingState;
  const accessBuildingsFilters = accessBuildings.filter(accessBuilding => reportFilter.buildings.some(building => building === accessBuilding.buildingId));

  const deleteFilter = (filterName) => {
    handleGetPermanenceReport({
      ...reportFilter,
      reg_from: 1,
      [filterName]: []
    })
  }

  const deleteFilterMulti = (filterName, value) => {
    const newValue = reportFilter[filterName].filter(filter => filter !== value);
    handleGetPermanenceReport({
      ...reportFilter,
      reg_from: 1,
      [filterName]: newValue
    })
  }

  const handleDeleteOpeningTablet = (openingCode) => {
    const newBuildingsFilter = accessBuildings.filter(accessBuilding => reportFilter.buildings.some(building => building === accessBuilding.buildingId && accessBuilding.opening.openingCode !== openingCode)).map(filter => filter.buildingId);
    const newData = {
      ...reportFilter,
      reg_from: 1,
      opening_code: reportFilter.opening_code.filter((el) => el !== openingCode),
      buildings: newBuildingsFilter
    }
    handleGetPermanenceReport(newData)
  }

  return (
    <div className='mt-2 mb-2'>
      <div className="d-flex align-items-center flex-wrap gap-3">

        {contractEmployeeTypeFilter &&
          <CustomTabletFilter
            withTooltip={true}
            placementTooltip={'top'}
            textTooltip={getTenantInfoByKey('hiring_modalities_name')}
            idTargetTooltip='contractEmployeeTypeFilterTooltip'
            filterName={contractEmployeeTypeFilter.description}
            deleteFilterFunction={() => deleteFilter('contract_type')}
          />}

        {contractorsFilter &&
          <CustomTabletFilter
            withTooltip={true}
            placementTooltip={'top'}
            textTooltip={t('CONT')}
            idTargetTooltip='contractorsFilterTooltip'
            filterName={contractorsFilter.contractor_name}
            deleteFilterFunction={() => deleteFilter('contractors')}
          />}

        {accessOpenigFilters.map((accessOpenigFilter, idx) =>
          <CustomTabletFilter
            key={idx}
            withTooltip={true}
            placementTooltip={'top'}
            textTooltip={getTenantInfoByKey('opening_name')}
            idTargetTooltip={`accessOpenigFilter-${idx}`}
            filterName={accessOpenigFilter.descripcion}
            deleteFilterFunction={() => handleDeleteOpeningTablet(accessOpenigFilter.codigo)}
          />
        )}

        {accessBuildingsFilters.map((accessBuildingFilter, idx) =>
          <CustomTabletFilter
            key={idx}
            withTooltip={true}
            placementTooltip={'top'}
            textTooltip={getTenantInfoByKey('building_name')}
            idTargetTooltip={`accessBuildingFilter-${idx}`}
            filterName={accessBuildingFilter.buildingDescription}
            deleteFilterFunction={() => deleteFilterMulti('buildings', accessBuildingFilter.buildingId)}
          />
        )}

      </div>
    </div>
  )
}

export default PermanenceTabletFilters